(() => {
  if (window.vorneuProductInitialized) return;
  window.vorneuProductInitialized = true;
  const showMedia = (root, id) => {
    const panels = [...root.querySelectorAll('[data-vn-media]')];
    if (!panels.some(p => p.dataset.vnMedia === id)) return;
    panels.forEach(panel => {
      panel.hidden = panel.dataset.vnMedia !== id;
      if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
    });
    root.querySelectorAll('[data-vn-thumb]').forEach(link => {
      if (link.dataset.vnThumb === id) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  };
  const updateVariant = root => {
    const select = root.querySelector('[data-vorneu-variant]');
    if (!select) return;
    const option = [...select.options].find(item => item.value === select.value);
    const button = root.querySelector('[name="add"]');
    const available = option?.dataset.available === 'true';
    root.querySelectorAll('[data-vorneu-current-price]').forEach(el => el.textContent = option?.dataset.price || '—');
    root.querySelectorAll('[data-vorneu-compare-price]').forEach(el => { el.textContent = option?.dataset.compare || ''; el.hidden = !option?.dataset.compare; });
    button.disabled = !available;
    button.textContent = option ? (available ? button.dataset.addLabel : button.dataset.soldLabel) : button.dataset.unavailableLabel;
    root.querySelector('[data-vn-variant-message]').hidden = !!option;
    const dynamic = root.querySelector('[data-vn-dynamic-checkout]');
    if (dynamic) dynamic.hidden = !available;
    if (!option) return;
    const quantity = root.querySelector('[name="quantity"]');
    quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
    let next = Math.max(Number(quantity.min), Number(quantity.value) || Number(quantity.min));
    next = Number(quantity.min) + Math.ceil((next - Number(quantity.min)) / Number(quantity.step)) * Number(quantity.step);
    if (quantity.max) next = Math.min(next, Number(quantity.max));
    quantity.value = String(next);
    if (option.dataset.media) showMedia(root, option.dataset.media);
    const url = new URL(window.location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
  };
  const init = scope => {
    scope.querySelectorAll('[data-vn-product]:not([data-vn-ready])').forEach(root => {
      root.dataset.vnReady = 'true';
      const select = root.querySelector('[data-vorneu-variant]');
      const first = root.querySelector('[data-vn-media]');
      const initialOption = select && [...select.options].find(item => item.value === select.value);
      showMedia(root, initialOption?.dataset.media || first?.dataset.vnMedia);
      const groups = root.querySelector('[data-vn-option-groups]');
      if (groups && select) {
        const variants = JSON.parse(root.querySelector('[data-vn-variants]').textContent);
        // The native select remains the no-JavaScript fallback and source for cart submissions.
        if (variants.length === select.options.length) {
          root._vnVariants = variants; groups.hidden = false;
          root.querySelector('.vn-variant-fallback').hidden = true;
        }
      }
    });
  };
  document.addEventListener('change', event => {
    const root = event.target.closest('[data-vn-product]'); if (!root) return;
    if (event.target.matches('[data-vn-option]')) {
      const groups = [...root.querySelectorAll('.vn-option-group')];
      const values = groups.map(group => group.querySelector('input:checked')?.value);
      groups.forEach((group, i) => group.querySelector('[data-selected-value]').textContent = values[i] || '');
      const variant = root._vnVariants.find(v => v.options.every((value, i) => value === values[i]));
      const select = root.querySelector('[data-vorneu-variant]');
      select.value = variant ? String(variant.id) : '';
      select.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (event.target.matches('[data-vorneu-variant]')) updateVariant(root);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-vn-thumb]'); if (!link) return;
    const root = link.closest('[data-vn-product]'); if (!root) return;
    event.preventDefault(); showMedia(root, link.dataset.vnThumb);
  });
  const pendingForms = new WeakSet();
  const restoreForms = new WeakMap();
  window.addEventListener('pageshow', event => {
    if (event.persisted) document.querySelectorAll('.vn-product-form').forEach(form => restoreForms.get(form)?.());
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.vn-product-form') || (event.submitter && event.submitter.name !== 'add')) return;
    const root = form.closest('[data-vn-product]');
    const feedback = form.querySelector('[data-vn-cart-feedback]');
    const message = form.querySelector('[data-vn-cart-error]');
    const button = form.querySelector('[name="add"]');
    if (!root?.dataset.cartAddUrl || !feedback || !message || !button || !window.fetch || !window.FormData) return;
    event.preventDefault();
    if (pendingForms.has(form) || button.disabled || !form.reportValidity()) return;
    const payload = new FormData(form);
    const endpoint = new URL(root.dataset.cartAddUrl, window.location.origin);
    if (endpoint.origin !== window.location.origin || !endpoint.pathname.endsWith('/cart/add')) return;
    endpoint.pathname += '.js';
    pendingForms.add(form);
    feedback.hidden = true;
    const controls = [...form.querySelectorAll('input, select, button, textarea')].map(control => [control, control.disabled]);
    controls.forEach(([control]) => { control.disabled = true; });
    const label = button.textContent;
    button.textContent = message.dataset.adding;
    form.setAttribute('aria-busy', 'true');
    const dynamic = form.querySelector('[data-vn-dynamic-checkout]');
    const wasDynamicHidden = dynamic?.hidden;
    if (dynamic) dynamic.hidden = true;
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 15000);
    const restore = () => {
      pendingForms.delete(form);
      controls.forEach(([control, disabled]) => { control.disabled = disabled; });
      button.textContent = label;
      form.removeAttribute('aria-busy');
      if (dynamic) dynamic.hidden = wasDynamicHidden;
      restoreForms.delete(form);
    };
    restoreForms.set(form, restore);
    let navigating = false;
    try {
      const response = await fetch(endpoint.href, { method: 'POST', body: payload, headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: controller.signal });
      const data = await response.json();
      if (!response.ok) {
        message.textContent = typeof data.description === 'string' ? data.description : message.dataset.fallback;
        feedback.hidden = false;
        feedback.focus();
        return;
      }
      if (!data.id && !data.items?.length) throw new Error('Unconfirmed cart response');
      const cart = new URL(root.dataset.cartUrl, window.location.origin);
      if (cart.origin !== window.location.origin) throw new Error('Invalid cart destination');
      // Keep the draft preview while using Shopify's locale-aware cart URL.
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) cart.searchParams.set('preview_theme_id', preview);
      window.location.assign(cart.href);
      navigating = true;
    } catch {
      // The server may have accepted the item before the connection failed. Never automatically retry.
      message.textContent = message.dataset.network;
      feedback.hidden = false;
      feedback.focus();
    } finally {
      window.clearTimeout(timer);
      if (!navigating) restore();
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const disclosure = event.target.querySelector('.vn-product-accordion'); if (disclosure) disclosure.open = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
})();
